import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectDbnpListItems } from '../../../../../../redux/dbnp/selector';
import { dbnp } from '../../../../../../redux/dbnp/action';
import * as R from 'ramda';
import PageLoader from '../../../../../../components/PageLoader';
import DbnpMappingComponent from '../components/dbnp-mapping.component';
import { dbnpMappings } from '../../../../../../redux/dbnp-mappings/action';
import { selectDbnpMappingQueryItems } from '../../../../../../redux/dbnp-mappings/selector';

const ManagementDbnpMapping = () => {   
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const dbnpMappingQuery = useSelector(selectDbnpMappingQueryItems)
  const dbnpItems = useSelector(selectDbnpListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
  const [
    selectedDbnpMapping,
    setSelectedDbnpMapping
  ] = useState<any>({})
 

  const fetchDbnpMappingById= ()=>{
    dispatch(dbnpMappings.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp-mappings/query`,entity:'dbnpMappings',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})

  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDbnpMapping({ ...selectedDbnpMapping, [field]: event });
  }

  useEffect(
    () => {
        dispatch(dbnp.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp/list`,entity:'dbnp',jsonData:{
    }})).then(()=>{
            if (parmas?.id > 0) {
                fetchDbnpMappingById()
                setIsLoading(false)
              }else {
                setIsLoading(false)
              }
           
          })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDbnpMapping(dbnpMappingQuery?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
     dispatch(dbnpMappings.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp-mappings`,entity:'dbnpMappings',jsonData:{
          
    Records: [
        selectedDbnpMapping
    ]
 
}})).then(()=>{
    back()
  })
  

    }else{
      dispatch(dbnpMappings.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dbnp-mappings`,entity:'dbnpMappings',jsonData:{
          
      Records: [
        selectedDbnpMapping
      ]
    
  }})).then(()=>{
    back()
  })
  
    }
   
    
  }

const back=()=>{
  navigate('/management/organization/dbn/dbnp-mappings')
} 
const fetchDbnpList = (dbnpId: any) => {
    const status = R.find(
      (item: any) => parseInt(
        item.Id,
        10
      ) === parseInt(
        dbnpId,
        10
      ),
      dbnpItems?.result?.items
    )
    selectedDbnpMapping.IsDBNPConsumerEnabled = status?.IsJoinAsDBNConsumer
    selectedDbnpMapping.ISDBNPProviderEnabled = status?.IsJoinAsDBNProvider
    selectedDbnpMapping.IsDBNPSupplierRoleEnabled = status?.IsJoinAsDBNSupplier
    selectedDbnpMapping.IsDBNPVendorRoleEnabled = status?.IsJoinAsDBNVendor
    selectedDbnpMapping.IsDBNPPartnerRoleEnabled = status?.IsJoingAsDBNPartner
  }
    return (
    <>
     {isLoading ? <PageLoader /> : 
          <DbnpMappingComponent 
           id={parmas.id}
           onFormChange={handleInnerFormChange}
           dbnp ={dbnpItems?.result?.items}
           selectedDbnpMapping={selectedDbnpMapping}
           fetchDbnpList={fetchDbnpList}
           back={back}
           handleFormSubmit={handleFormSubmit}
          /> 
        } 
          </>
    )
    
    }
   
    export default ManagementDbnpMapping;